import useOfferComparisonStore from '@/app/store/use-offer-comparison-store';
import {
  consumptionParam,
  currentTariffCostParam,
  gridOperatorNameParam,
  sizeParam,
  zipCodeParam,
  cityParam,
  streetParam,
  houseNumberParam,
} from '@/app/utils/energy-calculator-params';
import useEnergyCalculatorStore, {
  EnergyCalculatorState,
} from '@/app/store/use-energy-calculator-store';
import usePromoCodeStore from '../store/use-promo-code-store';
import { promoCodeParam } from './offer-params';

export const getShareUrl = () => {
  const currentTariffCost =
    useOfferComparisonStore.getState().currentTariffCost;
  const energyCalculatorState = useEnergyCalculatorStore.getState();
  const currentUrl = energyCalculatorState.selfLink;
  const queryParams = new URLSearchParams();
  const promoCode = usePromoCodeStore.getState();

  [
    sizeParam,
    consumptionParam,
    zipCodeParam,
    cityParam,
    streetParam,
    houseNumberParam,
    gridOperatorNameParam,
  ].forEach((key) => {
    if (energyCalculatorState[key as keyof EnergyCalculatorState]) {
      queryParams.append(
        key,
        energyCalculatorState[key as keyof EnergyCalculatorState] as string
      );
    }
  });

  if (currentTariffCost) {
    queryParams.append(currentTariffCostParam, currentTariffCost.toString());
  }
  if (promoCode.code) queryParams.append(promoCodeParam, promoCode.code);

  return `${currentUrl}?${queryParams}`;
};
